import {select} from '@ngneat/elf';

import {usersStore} from '@store/settings/users/users.store';
import {getUsersDataSource} from '@store/settings/users/users.requests';

export class UsersQuery {
  store = usersStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  users$ = getUsersDataSource.data$();

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const usersQuery = new UsersQuery();
